// extracted by mini-css-extract-plugin
export var container = "_n0-0";
export var dotAnimation = "_n0-2";
export var dotsLoading = "_n0-1";